var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import ReactTinyMarkup, { defaultRenderer } from 'react-tiny-markup';
import styled from 'styled-components';
var Styles = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  sub {\n    vertical-align: bottom;\n    font-size: 0.7em;\n    position: relative;\n    bottom: -0.5rem;\n  }\n  sup {\n    vertical-align: top;\n    font-size: 0.7em;\n    position: relative;\n    top: -0.5rem;\n  }\n  i {\n    font-style: italic;\n  }\n  b {\n    font-weight: bold;\n  }\n"], ["\n  sub {\n    vertical-align: bottom;\n    font-size: 0.7em;\n    position: relative;\n    bottom: -0.5rem;\n  }\n  sup {\n    vertical-align: top;\n    font-size: 0.7em;\n    position: relative;\n    top: -0.5rem;\n  }\n  i {\n    font-style: italic;\n  }\n  b {\n    font-weight: bold;\n  }\n"])));
var HTMLtext = function (_a) {
    var children = _a.children, _b = _a.additionalTags, additionalTags = _b === void 0 ? [] : _b, allowedAttributes = _a.allowedAttributes;
    var allowedTags = ['sup', 'sub', 'i'].concat(additionalTags);
    return (_jsx(Styles, { children: _jsx(ReactTinyMarkup, __assign({ allowedAttributes: allowedAttributes, renderer: function (p) {
                return p.tag && allowedTags.includes(p.tag)
                    ? defaultRenderer(p)
                    : p.children;
            } }, { children: children })) }));
};
export default HTMLtext;
var templateObject_1;
//# sourceMappingURL=index.js.map